import { NotificationManager } from 'react-notifications';
import { useApiMutation } from '@/hooks/api/useApiMutation';

export function useSendPushNotificationMutation(festivalId) {
  return useApiMutation(
    (payload) => `/admin/message/${festivalId}`,
    'post',
    {},
    {
      onSuccess: () => {
        NotificationManager.success('Notification sent', '', 3000);
      },
      onError: () => {
        NotificationManager.error('Could not send notification', '', 3000);
      },
    },
  );
}
